import { render } from "./SelectBookModal.vue?vue&type=template&id=44756558&scoped=true"
import script from "./SelectBookModal.vue?vue&type=script&lang=js"
export * from "./SelectBookModal.vue?vue&type=script&lang=js"

import "./SelectBookModal.vue?vue&type=style&index=0&id=44756558&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-44756558"

export default script